import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { CCommonPage } from '../models/page.models/commonPage.model';

@Injectable()
export class CommonPageService {
  constructor(private http: HttpClient) {

  }

  GetById(id: string) {
    return this.http.get<CCommonPage>(API_ServerAddress + 'api/CommonPages/' + id);
  }

}